import script from "./AddressManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressManagement.vue?vue&type=script&setup=true&lang=js"

import "./AddressManagement.vue?vue&type=style&index=0&id=540d2d52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-540d2d52"]])

export default __exports__